// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/distress-message-and-sequence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/distress-message-and-sequence/distress-message-and-sequence.js';

mount([g0]);
